import { skipToken, useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { QuestionThreadListDto } from '@lib/dto/question.dto'
import { useEnvelopeAccess } from '@/envelopes/EnvelopeAccess'
import { envelopeKeys } from '@/hooks/queryKeys'

export function useEnvelopeQuestions(id: string | undefined, enabled: boolean): UseQueryResult<QuestionThreadListDto> {
  const { service, cacheKey } = useEnvelopeAccess()
  return useQuery({
    queryKey: envelopeKeys.questions(cacheKey, id),
    queryFn: id && enabled ? () => service.listQuestions(id) : skipToken,
  })
}
